// =============================================================================
// couleurs.js — C, la palette d'accents PARTAGÉE (lot L10, 29/09/2026).
//
// Alignée sur les losanges du logo officiel Enio (Chantier 3, direction
// Mosaïque validée le 6/07/2026). MIROIR des jetons --acc-* de src/theme.css :
// toute modification se fait dans les deux fichiers (même commit). Des hex, et
// non des var() : C sert aussi dans des attributs SVG, des graphiques et des
// canevas, où var() n'existe pas. Une transparence s'écrit alpha(C.teal, .13)
// (src/alpha.js), jamais C.teal + "22" (src/pilotabilite.test.js).
//
// Module SANS dépendance, comme alpha.js et mouvement.js : n'importe quel écran
// l'importe sans cycle (uxComponents.js, que appShared.js importe, ne pouvait
// pas lire C d'appShared). appShared.js le réexporte. Les palettes locales
// `const C = {…}` ont disparu au lot L10 ; ne pas en recréer.
// =============================================================================
export const C = {
  navy:"#003F59", navyD:"#002C3F", navyL:"#0A4A63",
  orange:"#F49800", orangeL:"#FFB547",
  teal:"#1D948A", tealL:"#2FB9AD",
  violet:"#951B81", green:"#94C11F", red:"#E20816",
  beige:"#CBBB9F", white:"#ffffff", gray:"#8a9aaa",
  gold:"#F49800",
  blue:"#2AA9E1", magenta:"#D60B52",
};
